import { useTranslation } from "react-i18next";
import { COLOR_HOME } from "../../routes/color-constants";
import { ChangeEvent, useEffect, useState } from "react";
import { Actions, Field, Pager, Search, SearchValue, Sort } from "../../components/table/types";
import { Query, SortParam } from "../../common/api/Query";
import { Client } from "../../modules/clients/models/Client";
import { getClientContainer } from "../../container/client-modules";
import { ClientService } from "../../modules/clients/services/ClientService";
import { CLIENTS_SERVICE_KEY } from "../../modules/clients";
import editIcon from "../../assets/table-icons/edit-icon.svg";
import { AppTable } from "../../components/table";
import { useNavigate } from "react-router-dom";
import { URL_CLIENTS_ID } from "../../routes/routes-constants";

const clientService = getClientContainer().get<ClientService>(CLIENTS_SERVICE_KEY)

export const ClientTable = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [pager, setPager] = useState<Pager>()
    const [page, setPage] = useState<number>(0)
    const [count, setCount] = useState<number>(0)
    const [itemsPerPage, setItemsPerPage] = useState<number>(10)
    const [items, setItems] = useState<Client[]>([])
    const [sort, setSort] = useState<SortParam<Client>>({
        field: 'taxName',
        desc: true,
    })
    const [searcher, setSearcher] = useState<SearchValue<Client>[]>([])

    useEffect(() => {
        if (!isLoading) {
            return
        }

        clientService.getFilteredList(
            new Query({
                pager: { offset: page * itemsPerPage, limit: itemsPerPage },
                sort: [{ field: sort.field, desc: sort.desc }],
            })
        ).subscribe((res) => {
            setIsLoading(false)
            setItems(res.items)
            setCount(res.count)
        })
    }, [isLoading, searcher])

    useEffect(() => {
        setIsLoading(true)
        setPager({
            page,
            count,
            handleChangePage: handlePaginationChange,
            rowsPerPage: itemsPerPage,
            handleChangeRowsPerPage,
        })
    }, [page, count, itemsPerPage])

    const handlePaginationChange = (event: unknown, value: number) => setPage(value)

    const handleChangeRowsPerPage = (event: ChangeEvent<HTMLInputElement>) => {
        if (Number.isNaN(event.target.value)) {
            setItemsPerPage(10)
            return
        }
        setItemsPerPage(Number.parseInt(event.target.value))
    }

    const fields: Field<Client>[] = [
        {
            searchable: true,
            sortable: true,
            label: t('client'),
            name: 'taxName',
            renderFunc: (field, item) => item.fatherName + " - " + item.taxName,

        }
    ]


    console.log(items)
    const editClient = (client: Client) => navigate(URL_CLIENTS_ID.replace(':id', client.id || ''))

    const actions: Actions<Client> = {
        actionsColumn: t('Actions'),
        items: [
            {
                handler: editClient,
                icon: editIcon,
                label: t('Edit'),
                
            }
        ]
    }

    const search: Search<Client> = {
        searchValues: searcher,
        handleSearch: (svs: SearchValue<Client>[]) => {
            const result: SearchValue<Client>[] = []
            svs.forEach((s) => {
                if (s.type === "date" && s.value) {
                    result.push(Object.assign({ ...s }, { value: new Date(s.value as string).toISOString() }))
                } else {
                    result.push(s)
                }
            })
            setSearcher(result)
            setIsLoading(true)
        },
    }

    const sortable: Sort<Client> = {
        name: sort.field,
        direction: sort.desc ? 'desc' : 'asc',
        handleSort: (field) => {
            setSort({ field: field, desc: sort.field === field ? !sort.desc : true })
            setIsLoading(true)
        },
    }

    return (
        <>
            <AppTable
                styleHeader={{ color: COLOR_HOME }}
                actions={actions}
                fields={fields}
                items={items}
                rowKeyField={'id'}
                pager={pager}
                search={search}
                sort={sortable}
            />
        </>
    )
}
